import React, { useState, useEffect, useContext } from 'react';
import SinglePageForm from '../common/SinglePageForm';
import { Alert, Form } from 'antd';
import { logout } from '../services/user';
import { withRouter } from 'react-router-dom';
import AuthLogo from '../common/AuthLogo';
import { APP_CCX, CustomAppContext } from '../common/CustomAppContext';

export default withRouter(VerifyAccountPage);

/**
 * @name VerifyAccountPage
 * @desc component.
 */
function VerifyAccountPage({ history }) {
    const [error, setError] = useState(null);
    const { currentApp, getCustomAppPath } = useContext(CustomAppContext);

    useEffect(() => {
        (async () => {
            try {
                await logout(false);
                history.push(getCustomAppPath('/')); // redirect to login
            } catch (err) {
                setError(
                    `An error has occurred and your account has not been logged out, please refresh page: ${err.message}`
                );
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return error ? (
        <SinglePageForm data-testid="logout-form">
            <SinglePageForm.Content>
                <SinglePageForm.Header>
                    <AuthLogo currentApp={currentApp} className="" />
                </SinglePageForm.Header>
                <Form.Item>
                    <Alert
                        data-testid="logout-error"
                        message={error}
                        type="error"
                    />
                </Form.Item>
            </SinglePageForm.Content>
        </SinglePageForm>
    ) : null;
}
